import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
export default function SpannedTable() {
  const sourceWiseData = useSelector((state) => state.crd.sourceWiseData.data);
  const sourceWiseDataLoading = useSelector((state) => state.crd.sourceWiseData.loading);
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: 600,
        overflowY: 'auto',
        position: 'relative',
        border: '1px solid #98bcec',
      }}
    >
      <Table
        sx={{
          flex: 1,
          '& .MuiTableCell-root': {
            borderBottom: '1px solid #dfdfdfff',
            borderLeft: '1px solid #dfdfdfff',
          },
        }}
      >
        <TableHead
          sx={{
            bgcolor: '#98bcebff',
            position: 'sticky',
            top: 0,
          }}
        >
          <TableRow>
            <TableCell>Source</TableCell>
            <TableCell>Lead Type</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>Qualified</TableCell>
            <TableCell>Non Qualified</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sourceWiseDataLoading ? (
            <TableRow>
              <TableCell align="center" colSpan={5}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : sourceWiseData?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center" color="gray">
                No Data Found
              </TableCell>
            </TableRow>
          ) : (
            sourceWiseData.map((sourceItem, i) =>
              sourceItem.lead_types.map((lead, index) => (
                <TableRow key={`${i}-${index}`}>
                  {index === 0 && <TableCell rowSpan={sourceItem.lead_types.length}>{sourceItem.source}</TableCell>}

                  <TableCell>{lead.lead_type}</TableCell>
                  <TableCell>{lead.total}</TableCell>
                  <TableCell>{lead.qualified}</TableCell>
                  <TableCell>{lead.non_qualified}</TableCell>
                </TableRow>
              )),
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
